<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/byxCRB/tc-custom/9781504079990.jpg?1718046561817" alt="This image is the cover for the book Mistletoe and Murder, Amelia Adams"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mistletoe and Murder, Amelia Adams
      </h1>
      <p class="bookDescription body article font2">
        <b>A Christmas wedding . . . What could go wrong? </b><br/>  <br/> Amelia Adams has turned the Scottish mansion she inherited into a luxury hotel. As the festive season gets underway, she prepares to host the wedding of a millionaire to his young fiancée.<br/>  <br/> But when Amelia gets a mysterious call from a stranger who says he has something to tell her, she is intrigued. And when a string of shocking events unfold, and the bodies start to mount up, Amelia must uncover the truth.<br/>  <br/> Will there be a wedding under the mistletoe?<br/>  <br/> Or will a killer get away with murder?<br/>  <br/> “A wonderful read!” —Amazon reviewer, five stars<br/>  <br/> “I love the story . . . couldn’t put it down.” —Amazon reviewer, five stars<br/>  <br/> “Lovely book to curl up with by the fire.” —Amazon reviewer, five stars
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Laura Stewart
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d38cbd28